module.exports = __webpack_public_path__ + "img/arrow-right.a555d2de.svg";